import { useMemo } from "react";
import { makeStyles } from "@mui/styles";
import { Box, Link, Typography } from "@mui/material";

import noMatch from "../assets/404.png";

const useStyles = makeStyles(() => ({
  image: {
    objectFit: "contain",
    maxHeight: 100,
    marginTop: 100,
    marginBottom: 20,
  },
}));

export default function NoMatch() {
  const classes = useStyles();

  const header = useMemo(
    () => ({
      fontSize: 22,
      fontWeight: 800,
      lineHeight: "26px",
      color: "primary.main",
    }),
    []
  );

  const subHeader = useMemo(
    () => ({
      fontSize: 18,
      fontWeight: 700,
      lineHeight: "31px",
      color: "primary.main",
    }),
    []
  );

  return (
    <Box display="flex" justifyContent="center" flexDirection="column">
      <img src={noMatch} alt="Not found" className={classes.image} />
      <Typography align="center" sx={header}>
        We couldn’t find the page you were looking for :(
      </Typography>
      <Typography align="center" sx={subHeader}>
        Maybe try <Link href="/search">browsing our activities! </Link>
      </Typography>
    </Box>
  );
}
